module.exports = __webpack_public_path__ + "static/media/hair-dryer.3c5a18d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/Features/hair-dryer.png
// module id = 27
// module chunks = 0